import DOMPurify from "dompurify";
import { marked } from "marked";

const ALLOWED_TAGS = ["p", "br", "strong", "em", "b", "i", "ul", "ol", "li", "code", "pre"];

/** Render a configuration-help answer so markdown bold and lists show as formatting. */
export function renderSupportMarkdown(content: string): string {
  const html = marked.parse(String(content || ""), { async: false, gfm: true, breaks: true }) as string;
  return DOMPurify.sanitize(html, {
    ALLOWED_TAGS,
    ALLOWED_ATTR: [],
  });
}
